<template>
    <popup-modal ref="popup" :width="'600px'">
        <button class="leaving-modal" @click="closeModal">
            <img style="width: 16px" :src="closeImg" alt="Close" />
        </button>
        <h2>{{ title }}</h2>
        <div class="grades-table">
            <table>
                <thead>
                    <tr>
                        <th>Categories</th>
                        <th>Weight</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in this.courseCategoryData" :key="index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.weight }}%</td>
                    </tr>
                    <tr class="total-row">
                        <td><strong>Total</strong></td>
                        <td class="total">{{ totalWeight }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </popup-modal>
</template>

<script>
import { getCategory, getCourseCategory } from "@/models/grade_book";
import PopupModal from "../modal/confirmModal.vue";
export default {
    name: "ConfirmDialogue",
    components: { PopupModal },
    props: {
        componentGradebook: {
            type: Array,
            default: () => [
                { category: 'Assignment', weight: '20%' },
                { category: 'Progress test', weight: '20%' },
                { category: 'End-of-semester test', weight: '40%' },
                { category: 'Participation', weight: '20%' }
            ]
        },
    },
    data: () => ({
        closeImg: "/themes/web/assets/images/icon/icon-del-dialog.png",
        title: undefined,
        courseCategoryData: null,
        courseId: null,
    }),
    mounted() {
    },
    methods: {
        async getCourseCategoryIpl() {
            const params = {
                course_id: this.courseId,
            };
            await getCourseCategory(params)
                .then((response) => {
                    if (response.data.data?.length) {
                        this.courseCategoryData = response.data.data
                    }
                })
                .catch(({ response }) => {
                    console.log("getCourseGradebook failed, please try again later.");
                });
        },
        async show(opts = {}) {
            this.title = opts.title;
            this.courseId = opts.courseId;
            await this.getCourseCategoryIpl();
            this.$refs.popup.open();
        },
        closeModal() {
            this.$refs.popup.close();
        },
    },
    computed: {
        totalWeight() {
            return this.courseCategoryData?.reduce((sum, item) => {
                return sum + ((item.weight * 100) / 100)
            }, 0)
        }
    }
};
</script>

<style scoped>
h2 {
    margin-top: 0;
    font-size: 24px;
    font-weight: 700;
    padding: 4px 48px;
    letter-spacing: 0.48px;
    color: #212529;
}

.leaving-modal {
    padding: 7px 10px;
    border-radius: 48px;
    border: 1px solid var(--Cloud-Dark, #cfcfcf);
    background: var(--Creme-Light, #fff);
    box-shadow: 0px 4px 0px 0px #d2d2d2;
    position: absolute;
    right: 1px;
    top: 1px;
    height: 40px;
}

.leaving-modal img {
    max-width: 100%;
}

.popup-modal {
    background: linear-gradient(180deg,
            rgba(56, 23, 112, 0.5) 0%,
            rgba(127, 44, 134, 0.5) 100%) !important;
    backdrop-filter: blur(12px) !important;
}

.grades-table {
    background: #fff;
    margin: 16px;
    border: 0.5px solid #f0f0f0;
    border-radius: 24px;
    overflow: hidden;
}

.grades-table table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.grades-table th,
.grades-table td {
    border: 0.5px solid #f0f0f0;
    padding: 12px;
}

.grades-table th {
    background: #e0e0e0;
    text-align: left;
    font-weight: 600;
    font-size: 16px;
    color: black;
}

.grades-table td {
    color: black;
    font-size: 16px;
    font-weight: 400;
}

.total {
    font-weight: 600 !important;
    color: #28a745 !important;
}
</style>
